import { useState, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { FadeUp } from '@happymoneyinc/move'

import Display from '../Display'
import Container from '../Container'
import Headline from '../Headline'

import Department from './Department'

const OpenJobs = (props) => {
  const { departments } = props

  const [currentDepartment, setCurrentDepartment] = useState('')
  const [allDepartments, setAllDepartments] = useState([])
  const [filteredDepartments, setFilteredDepartments] = useState([])
  const [isFiltered, setIsFiltered] = useState(false)

  useEffect(() => {
    setFilteredDepartments(departments)
    setAllDepartments(departments)
  }, [departments])

  const filterDepartments = (e) => {
    const { value } = e.target
    setCurrentDepartment(value)

    if (value === 'all') {
      setFilteredDepartments(allDepartments)
      setIsFiltered(false)
      return
    }

    setFilteredDepartments(
      allDepartments.filter((department) => department.title === value)
    )
    setIsFiltered(true)
  }

  return (
    <div id="jobs">
      <Wrapper>
        <FadeUp>
          <HeadingWrapper>
            <StyledDisplay size="medium" element="h2">Current Job Openings</StyledDisplay>

            <CircleIcon>
              <Image src="/100_remote.svg" alt="100% remote circle" width={126} height={126} />
            </CircleIcon>

          </HeadingWrapper>

          <StyledHeadline size="small">View by Department:</StyledHeadline>
          <SelectWrapper>
            <Select data-testid="department-filter" aria-label="department filter" value={currentDepartment} onChange={filterDepartments}>
              <>
                <option value="all">All</option>
                {departments.map((department) => (
                  <option key={department.title} value={department.title}>
                    {department.title}
                  </option>
                ))}
              </>
            </Select>
            <Caret />
          </SelectWrapper>

          {filteredDepartments.map((department) => (
            <Department
              department={department}
              key={department.title}
              isFiltered={isFiltered}
              testID={`department-container-${ department.title.toLowerCase().replace(/\s/g, '-') }`}
            />
          ))}
        </FadeUp>
      </Wrapper>
    </div>
  )
}

const CircleIcon = styled.div`
  display: inline-block;
  width: 80px;
  margin-left: -1vw;
  transform: rotate(-13.68deg);

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    width: 126px;
  }
`

const HeadingWrapper = styled.div`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  display: flex;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.sm }) {
    align-items: baseline;
    flex-direction: row;
    margin-top: 40px;
    margin-left: 60px;
  }
`

const StyledDisplay = styled(Display)`
  display: inline;
  margin-bottom: 0;
`

const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;
  height: 62px;
  min-width: 219px;
  margin: 0 auto 60px;
  background: ${ ({ theme }) => theme.colors.azure[2] };
  border-radius: 80px;
  cursor: pointer;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.sm }) {
    margin: 0 auto 80px;
  }
`

const Select = styled.select`
  width: 100%;
  height: 62px;
  padding: 0 40px 0 32px;
  font-family: ${ ({ theme }) => `${ theme.fonts.InterRegular }` };
  font-size: 17.5px;
  appearance: none;
  background: transparent;
  box-shadow: none;
  border: none;
  border-radius: 80px;
  cursor: pointer;
`

const Caret = styled.i`
  position: absolute;
  top: 48%;
  right: 26px;
  display: inline-block;
  padding: 3px;
  border: solid ${ ({ theme }) => theme.colors.black };
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translateY(-3px);
`

const StyledHeadline = styled(Headline)`
  margin-top: 60px;
  margin-bottom: 24px;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.sm }) {
    margin-top: 24px;
    margin-bottom: 24px;
  }
`

const Wrapper = styled(Container)`
  text-align: center;
  background-color: ${ ({ theme }) => theme.colors.cream };
`

OpenJobs.propTypes = {
  departments: PropTypes.arrayOf(PropTypes.shape({})).isRequired
}

export default OpenJobs

